export default "__VITE_ASSET__CM7jcOFM__"